import { Badge } from "@/components/ui/badge"
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group"
import type { GenreCount } from "@/lib/songs"
import { cn } from "@/lib/utils"

interface GenreFiltersProps {
  genres: GenreCount[]
  totalCount: number
  selected: string[]
  onToggle: (genre: string) => void
  onClear: () => void
}

export function GenreFilters({
  genres,
  totalCount,
  selected,
  onToggle,
  onClear,
}: Readonly<GenreFiltersProps>) {
  return (
    <div
      className="flex flex-wrap items-center gap-2"
      role="group"
      aria-label="장르 필터"
    >
      <button
        type="button"
        onClick={onClear}
        aria-pressed={selected.length === 0}
        className={cn(
          "flex items-center gap-1.5 rounded-3xl border px-3 py-1.5 text-xs font-medium transition-colors",
          selected.length === 0
            ? "border-primary bg-primary text-primary-foreground"
            : "border-border bg-background text-muted-foreground hover:bg-muted"
        )}
      >
        전체
        <Badge
          variant={selected.length === 0 ? "secondary" : "outline"}
          className={cn(
            selected.length === 0 && "bg-primary-foreground/20 text-inherit"
          )}
        >
          {totalCount}
        </Badge>
      </button>

      <ToggleGroup
        type="multiple"
        variant="outline"
        spacing={2}
        value={selected}
        onValueChange={() => undefined}
        className="flex flex-wrap gap-2"
      >
        {genres.map((genre) => (
          <ToggleGroupItem
            key={genre.name}
            value={genre.name}
            onClick={() => onToggle(genre.name)}
            className="flex items-center gap-1.5 rounded-3xl! px-3 py-1.5 text-xs"
          >
            {genre.name}
            <Badge
              variant={selected.includes(genre.name) ? "secondary" : "outline"}
            >
              {genre.count}
            </Badge>
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  )
}
